var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-icons__item"},[_c('span',{ref:"tooltip"},[_c('img',{attrs:{"src":_vm.src,"alt":_vm.name}})])])}
var staticRenderFns = []

export { render, staticRenderFns }